import { __require as requireDescriptors } from './node_modules-core-js-internals-descriptors.js';
import { __require as requireFails } from './node_modules-core-js-internals-fails.js';
import { __require as requireDocumentCreateElement } from './node_modules-core-js-internals-document-create-element.js';

var ie8DomDefine;
var hasRequiredIe8DomDefine;

function requireIe8DomDefine () {
	if (hasRequiredIe8DomDefine) return ie8DomDefine;
	hasRequiredIe8DomDefine = 1;
	var DESCRIPTORS = requireDescriptors();
	var fails = requireFails();
	var createElement = requireDocumentCreateElement();

	// Thanks to IE8 for its funny defineProperty
	ie8DomDefine = !DESCRIPTORS && !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(createElement('div'), 'a', {
	    get: function () { return 7; }
	  }).a !== 7;
	});
	return ie8DomDefine;
}

export { requireIe8DomDefine as __require };
//# sourceMappingURL=node_modules-core-js-internals-ie8-dom-define.js.map
